import ComponentManager from '@/Management/ComponentManager';
import Window from '@/Controls/Window';
import ActivityFeedOptionsWindowViewModel from '@/Components/ActivityFeed/Options/ActivityFeedOptionsWindowViewModel';
import layout from './ActivityFeedOptionsWindow.html?raw';
export default class ActivityFeedOptionsWindow extends Window {
    /**
     * @override
     */
    public viewModel: ActivityFeedOptionsWindowViewModel;

    constructor(viewModel: ActivityFeedOptionsWindowViewModel) {
        const $element = $('<div>').addClass('activity-feed-options-window-wrapper');
        super(viewModel, $element);

        this.applyTemplate(layout, $element);
    }

    /**
     * @override
     */
    public getElementToAppended(): JQuery<HTMLElement> {
        return $('[data-region=Modal]');
    }
}

ComponentManager.setControl('ActivityFeedOptionsWindow', ActivityFeedOptionsWindow, 'RADPresentation.HTMLClient.DefaultViewExtensions');